import React from 'react';
import { Query, withApollo } from "react-apollo";

import { mails, mail } from '../../graphql/queries';
import { readMail } from '../../graphql/mutations';
import { REGX, escapeHTML } from '../../util';
import { formatDateTime } from '../../date3';

import { ColHead, ColError, ColLoading } from '../chunk';
import MailDelete from './MailDelete';

class MailList extends React.Component {

	formatMessage = (body) => {
        body = escapeHTML(body);
        return body.replace(REGX.url, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
    }

	mutate() {
		this.props.client.mutate({
			mutation: readMail,
			variables: {
				id: this.props.match.params.id
			},
			refetchQueries: [{query: mails}]
		})
		.catch(e => {
			alert('Read Mail Error: ' + e);
		});
	}

	render() {

		return (
			<Query query={mail} variables={{ id: this.props.match.params.id }}>
                {({ loading, error, data }) => {
                    if (loading) return (<div className="col col-2"><ColLoading /></div>)
                    if (error) return (<div className="col col-2"><ColError error={error} /></div>)

                    if (!data.mail) return (<div className="col col-2"><ColError error={{ message: 'Mail not found.' }}  /></div>)

                    if (data.mail.unread) {
						this.mutate();
					}

					return (
                        <div className="col col-2">
                            <div className="col__actions">
                                <MailDelete id={this.props.match.params.id} />
                            </div>
							<ColHead icon="envelope-open" title={data.mail.subject} meta={formatDateTime(data.mail.dateSent)} />
			
							<section className="richtext break-word">
								<h2>
									FR: <a href={`mailto:${data.mail.from}`}>{data.mail.from}</a><br />
									TO: {data.mail.to}<br />
									{data.mail.cc && `CC: ${data.mail.cc}`}
								</h2>
				
								<p className="font-mono" dangerouslySetInnerHTML={{__html: this.formatMessage(data.mail.body)}}></p>
							</section>
						</div>
					)
				}}
			</Query>
		);
	}
}


export default withApollo(MailList)


// WEBPACK FOOTER //
// ./src/components/mail/MailDetail.js